import {Injectable}                                      from '@angular/core';
import {map}                                             from 'rxjs/operators';
import {nameOf}                                          from '../../../../ap-core/utils/ap-name-of';
import {
  ApDynGridPropertyColumnConfig,
  FilterType
}                                                        from '../../../../ap-dyngrids/config/ap-dyn-grid-property-column-config';
import {
  ApDynGridColumnConfigBase,
  ApDynGridColumnHideConfig
}                                                        from '../../../../ap-dyngrids/config/ap-dyn-grid-column-config-base';
import {MapViewMode}                                     from '../../../../ap-interface';
import {MapViewStore}                                    from '../../../../stores/layout/mapview.store';
import {ApGuidUtil, ApTimeSpanUtil, GetRoundNumericPipe} from '../../../../ap-utils';
import {
  ApDynGridGroupColumnConfig
}                                                        from '../../../../ap-dyngrids/config/ap-dyn-grid-group-column-config';
import {
  ApDynGridEditColumnConfig
}                                                        from '../../../../ap-dyngrids/config/ap-dyn-grid-edit-column-config';
import {
  DropDownButtonData
}                                                        from '../../../../ap-dyngrids/config/ap-dyn-grid-button-column-config';
import {
  ApDynformsConfigFieldset
}                                                        from '../../../../ap-dynforms/config/ap-dynforms-config-fieldset';
import {
  ApDynformsConfigComboBox
}                                                        from '../../../../ap-dynforms/config/ap-dynforms-config-combobox';
import {
  ApDynformsConfigNumerictextbox
}                                                        from '../../../../ap-dynforms/config/ap-dynforms-config-numerictextbox';
import {
  ApDynformsConfigTextarea
}                                                        from '../../../../ap-dynforms/config/ap-dynforms-config-textarea';
import {
  GetRoundNumericService
}                                                        from '../../../../ap-utils/service/get-round-numeric.service';
import {FieldStore}                                      from '../../../../stores/farm/field.store';
import {UnitsStore}                                      from '../../../../stores/common/units.store';
import {LoginStore}                                      from '../../../../stores/login/login.store';
import {CampaignYearStore}                               from '../../../../stores/login/campaignyear.store';
import {WorkTypesStore}                                  from '../../../../stores/base-data/worrktypes.store';
import {ApDateService}                                   from '../../../../ap-core/services/ap-date-service';
import {
  ApTranslationService
}                                                        from '../../../../ap-utils/service/ap-translation.service';
import {InstrumentStore}                                 from '../../../../stores/docu/instrument.store';
import {DriverStore}                                     from '../../../../stores/docu/driver.store';
import {MachineStore}                                    from '../../../../stores/docu/machine.store';
import {WorktypeUnitStore}                               from '../../../../stores/base-data/worktype-unit.store';
import {TimeAreaService}                                 from '../../../../services/data/time-area.service';
import {TimeFormatPipe}                                  from '../../../../ap-utils/pipes/ap-format-duration.pipe';
import {
  FormatType
}                                                        from '../../../../ap-utils/types/ap-format-duration.types';
import {
  IFwPlanPlanningWizardDetailsData,
  IFwPlanPlanningWizardOverviewData,
  IFwPlanPlanningWizardSelectionData,
  IFwPlanPlanningWizardSingleEditData
}                                                        from '../fw-plan-planning.types';
import {FwPlanPlanningCommonConfig}                      from './fw-plan-planning-common.config';
import {
  ApTooltipContentService
}                                                        from '../../../../ap-utils/service/ap-tooltip-content.service';
import {
  ApDynformsConfigPlaceholder
}                                                        from '../../../../ap-dynforms/config/ap-dynforms-config-placeholder';
import {Observable}                                      from 'rxjs';
import IUnit = Data.Common.IUnit;
import ILanguage = Data.Language.ILanguage;
import ISettings = Data.BaseData.ISettings;
import IFieldWorkPlanBook = Data.TaskManagement.IFieldWorkPlanBook;
import TaskManagementStatus = Data.TaskManagement.TaskManagementStatus;
import IFieldWorkSummary = Data.TaskManagement.IFieldWorkSummary;

@Injectable()
export class FwPlanPlanningOverviewConfig {
  constructor(private fieldStore: FieldStore,
              private unitsStore: UnitsStore,
              private loginStore: LoginStore,
              private driverStore: DriverStore,
              private machineStore: MachineStore,
              private mapViewStore: MapViewStore,
              private workTypeStore: WorkTypesStore,
              private instrumentStore: InstrumentStore,
              private workTypeUnitStore: WorktypeUnitStore,
              private campaignYearStore: CampaignYearStore,
              private dateService: ApDateService,
              private timeAreaService: TimeAreaService,
              private translationService: ApTranslationService,
              private roundNumericService: GetRoundNumericService,
              private tooltipContentService: ApTooltipContentService,
              private roundNumericPipe: GetRoundNumericPipe,
              private timeFormatPipe: TimeFormatPipe,
              private fwPlanPlanningWizardCommonConfig: FwPlanPlanningCommonConfig) {
  }

  /**
   * Generates grid column configuration for displaying field work planning wizard overview data.
   * @param language - The language configuration for localization
   * @param setting - Application settings containing formatting preferences
   * @param dorpDownData - Optional dropdown button data for edit column
   * @returns Array of grid column configurations including field number, name, area, dates, resources, etc.
   * @public
   */
  public generateColumns(language: ILanguage, setting: ISettings,
                         dorpDownData?: DropDownButtonData[]): ApDynGridColumnConfigBase[] {
    return [
      new ApDynGridPropertyColumnConfig({
        title: 'Docu_Ini__Number',
        field: `${nameOf<IFwPlanPlanningWizardOverviewData>('SelectionData')}.${nameOf<IFwPlanPlanningWizardSelectionData>('FieldNumber')}`,
        width: 60,
        cssClass: 'right',
        hide: true,
        filterable: true,
        filterType: FilterType.NUMBER,
        headerFilterable: true
      }),
      new ApDynGridPropertyColumnConfig({
        title: 'Docu_Ini_Subnumber',
        field: `${nameOf<IFwPlanPlanningWizardOverviewData>('SelectionData')}.${nameOf<IFwPlanPlanningWizardSelectionData>('FieldSecondNumber')}`,
        width: 60,
        cssClass: 'right',
        hide: true,
        filterable: true,
        filterType: FilterType.NUMBER,
        headerFilterable: true
      }),
      new ApDynGridPropertyColumnConfig({
        title: 'Docu_Ini__Number',
        field: `${nameOf<IFwPlanPlanningWizardOverviewData>('SelectionData')}.${nameOf<IFwPlanPlanningWizardSelectionData>('FieldCombinedNumber')}`,
        width: 70,
        hide: new ApDynGridColumnHideConfig({
          selfHide: this.mapViewStore.Listen(s => s.mode).pipe(map((mode) => mode === MapViewMode.HIDE))
        }),
        filterable: true,
        headerFilterable: true,
      }),
      new ApDynGridPropertyColumnConfig({
        title: 'Docu_Ini__Name',
        field: `${nameOf<IFwPlanPlanningWizardOverviewData>('SelectionData')}.${nameOf<IFwPlanPlanningWizardSelectionData>('FieldName')}`,
        width: 180,
        sortIndex: 0,
        filterable: true,
        headerFilterable: true
      }),
      new ApDynGridPropertyColumnConfig({
        title: 'Docu_Ini__Area',
        field: `${nameOf<IFwPlanPlanningWizardOverviewData>('SelectionData')}.${nameOf<IFwPlanPlanningWizardSelectionData>('Area')}`,
        width: 60,
        cssClass: 'right',
        tooltip: (dataItem: IFwPlanPlanningWizardOverviewData) => this.roundNumericService.stringify(dataItem?.SelectionData?.Area, 4),
        filterable: true,
        filterType: FilterType.NUMBER,
        headerFilterable: true,
        pipes: [{
          pipe: this.roundNumericPipe,
          args: [setting.DigitsAfterDecimalPoint]
        }]
      }),
      new ApDynGridPropertyColumnConfig({
        title: 'Base__SortItemDate',
        field: `${nameOf<IFwPlanPlanningWizardOverviewData>('PlanBook')}.${nameOf<IFieldWorkPlanBook>('ApplicationDate')}`,
        format: language.DateFormat,
        hide: true,
        width: 70,
        headerFilterable: true
      }),
      new ApDynGridPropertyColumnConfig({
        title: 'Global_Value',
        field: `${nameOf<IFwPlanPlanningWizardOverviewData>('PlanBook')}.${nameOf<IFieldWorkPlanBook>('Value')}`,
        hide: true,
        width: 70,
        headerFilterable: true
      }),
      new ApDynGridPropertyColumnConfig({
        title: 'Settings__Lbl_Menu_Unit',
        field: nameOf<IFwPlanPlanningWizardOverviewData>('Unit'),
        hide: true,
        width: 70,
        headerFilterable: true
      }),
      new ApDynGridPropertyColumnConfig({
        title: 'Docu_Ini__StartTime',
        field: nameOf<IFwPlanPlanningWizardOverviewData>('Start'),
        format: 'HH:mm',
        hide: true,
        width: 70,
        headerFilterable: true
      }),
      new ApDynGridPropertyColumnConfig({
        field: nameOf<IFwPlanPlanningWizardOverviewData>('DurationInMilliseconds'),
        title: `${this.translationService.translate('TotalTime')} [${this.translationService.translate('Base__UnitH')}]`,
        hide: true,
        width: 70,
        cssClass: 'right',
        headerFilterable: true,
        tooltip: (dataItem: IFwPlanPlanningWizardOverviewData) => this.tooltipContentService.getCapacityPerformanceTooltip(dataItem.HaPerHour),
        pipes: [{
          pipe: this.timeFormatPipe,
          args: [{
            formatType: FormatType.Decimals,
            suffixValue: 'Base__UnitH',
            decimalsFormatOptions: {
              decimalsCount: 1,
              decimalsSeparator: language.DecimalSeperator
            }
          }]
        }]
      }),
      new ApDynGridGroupColumnConfig({
        title: 'Settings__Lbl_Menu_Resources',
        hide: true,
        groupColumns: [
          new ApDynGridPropertyColumnConfig({
            field: nameOf<IFwPlanPlanningWizardOverviewData>('Machine'),
            title: 'Base__Engine',
            width: 100,
            hide: true,
            headerFilterable: true
          }),
          new ApDynGridPropertyColumnConfig({
            field: nameOf<IFwPlanPlanningWizardOverviewData>('Instrument'),
            title: 'AgriConnect_Ini__Tool',
            width: 100,
            hide: true,
            headerFilterable: true
          }),
          new ApDynGridPropertyColumnConfig({
            field: nameOf<IFwPlanPlanningWizardOverviewData>('Driver'),
            title: 'Docu_Ini__Motorist',
            width: 100,
            hide: true,
            headerFilterable: true
          })
        ]
      }),
      new ApDynGridEditColumnConfig({
        data: dorpDownData
      })
    ];
  }

  /**
   * Generates a list of modal dialog fieldsets to configure and display form fields
   * for the planning wizard's single edit modal dialog based on provided data.
   * @param overviewItem - Overview data containing plan information such as work type and area.
   * @param singleEditData - Data for single edit operations including values, units, and notes.
   * @param modalDialogChanges$ - Observable providing updates during modal dialog interaction.
   * @return An array of configuration fieldsets defining the structure and behavior of the form fields.
   * @public
   */
  public generateModalDialogFields(overviewItem: IFwPlanPlanningWizardOverviewData,
                                   singleEditData: IFwPlanPlanningWizardSingleEditData,
                                   modalDialogChanges$: Observable<IFwPlanPlanningWizardSingleEditData>): ApDynformsConfigFieldset[] {
    const workTypeUnits = this.workTypeUnitStore.getUnitsByWorktype(overviewItem.PlanBook.WorkType.Id);
    return [
      this.fwPlanPlanningWizardCommonConfig.getGeneralFieldSet(singleEditData, true, true),
      new ApDynformsConfigFieldset({
        key: 'WorkInformation',
        legend: 'Work_Information',
        useMaxWidth: true,
        config: [
          new ApDynformsConfigNumerictextbox({
            key: nameOf<IFwPlanPlanningWizardSingleEditData>('Value'),
            label: 'Worktype_Value',
            value: singleEditData.Value,
            disabled: !Number.isFinite(singleEditData.Value)
          }),
          new ApDynformsConfigComboBox({
            key: nameOf<IFwPlanPlanningWizardSingleEditData>('Unit'),
            label: 'Worktype_Unit',
            valueField: nameOf<IUnit>('Id'),
            textField: nameOf<IUnit>('Key'),
            value: singleEditData.Unit,
            options: workTypeUnits,
            disabled: workTypeUnits.length < 2,
            translate: true,
            valuePrimitive: true
          }),
          new ApDynformsConfigTextarea({
            key: nameOf<IFwPlanPlanningWizardSingleEditData>('Notes'),
            label: 'Global__Note',
            rows: 2
          })
        ]
      }),
      new ApDynformsConfigFieldset({
        key: 'Docu',
        legend: 'Settings__Lbl_Menu_Resources',
        useMaxWidth: true,
        config: [
          ...this.fwPlanPlanningWizardCommonConfig.getResourcesConfigs(singleEditData),
          new ApDynformsConfigPlaceholder(),
          new ApDynformsConfigNumerictextbox({
            key: nameOf<IFwPlanPlanningWizardSingleEditData>('DurationInHours'),
            label: `${this.translationService.translate('Docu_Ini__Duration')} [${this.translationService.translate('Base__UnitH')}]`,
            value: singleEditData.DurationInHours,
            decimals: 1,
            min: 0,
            step: 0.1
          }),
          new ApDynformsConfigNumerictextbox({
            key: nameOf<IFwPlanPlanningWizardSingleEditData>('HaPerHour'),
            label: `${this.translationService.translate('FieldAreaPerformance')} [${this.translationService.translate('Unit_ha_per_h')}]`,
            value: singleEditData.HaPerHour,
            value$: modalDialogChanges$.pipe(
              map(c => {
                if (!Number.isFinite(overviewItem.SelectionData.Area) || !Number.isFinite(c.DurationInHours)) {
                  return 0;
                }
                const result = overviewItem.SelectionData.Area / c.DurationInHours;
                return Number.isFinite(result) ? result : 0;
              })
            ),
            decimals: 1,
            min: 0,
            step: 0.1,
            disabled: true
          })
        ]
      })
    ];
  }

  /**
   * Creates IFieldWorkPlanBook entries for saving based on details and selection data.
   * @param detailsData - Details data containing work type, unit, date, and other information
   * @param selectionData - Array of selected field data to create plan books for
   * @returns Array of IFieldWorkPlanBook objects for saving
   * @public
   */
  public getPlanBooksForSaving(detailsData: IFwPlanPlanningWizardDetailsData,
                               selectionData: IFwPlanPlanningWizardSelectionData[]): IFieldWorkPlanBook[] {
    const campaignYear = this.campaignYearStore.SelectedCampaignYear.Year;
    const applicationDate = this.dateService.getDateNoon(detailsData.ApplicationDate);
    const workType = this.workTypeStore.WorkTypes.find(wt => wt.Id === detailsData.WorkType);
    const unit = this.unitsStore.Units.find(u => u.Id === detailsData.Unit);
    const instrument = this.instrumentStore.getInstrumentById(detailsData.Instrument);
    const summary = {
      Id: ApGuidUtil.generateNewGuid(),
      CampaignYear: campaignYear,
      Note: detailsData.Notes,
      UserValue: detailsData.Value,
      UserUnit: unit,
      WorkType: workType,
      FarmId: this.loginStore.SelectedFarmId,
      BookedBy: null,
      BookedAt: null,
      DeletedAt: null,
      CreatedAt: null,
      UpdatedAt: null,
      DeletedBy: null,
      UpdatedBy: null,
      CreatedBy: null,
      ChangedAt: null,
      ChangedBy: null,
      Version: 0
    } as IFieldWorkSummary;
    return selectionData.map(selectionItem => {
      const fieldGeom = this.fieldStore.getFieldGeomById(selectionItem?.FieldGeomId);
      const duration = this.timeAreaService.getTotalDurationInMilliseconds(fieldGeom?.AreaHa, detailsData.HaPerHour);
      return {
        Id: ApGuidUtil.generateNewGuid(),
        ApplicationDate: applicationDate,
        ExportDriver: detailsData.Driver,
        ExportInstrument: detailsData.Instrument,
        ExportMachine: detailsData.Machine,
        FieldGeomId: selectionItem?.FieldGeomId,
        FieldId: selectionItem?.Id,
        Summary: summary,
        SummaryId: summary.Id,
        FarmId: summary.FarmId,
        Unit: summary.UserUnit,
        Value: summary.UserValue,
        WorkType: summary.WorkType,
        CampaignYear: summary.CampaignYear,
        Geom: fieldGeom?.Geom,
        Start: ApTimeSpanUtil.getTimeSpanFromDate(detailsData.Start, true),
        Duration: ApTimeSpanUtil.getTimeSpanFromMilliseconds(duration, true),
        Status: TaskManagementStatus.Green,
        WorkingWidth: instrument?.DefaultWidth ?? 0,
        Area: 0,
        AreaHa: 0,
        Note: '',
        Details: [],
        BookedBy: null,
        BookedAt: null,
        DeletedAt: null,
        CreatedAt: null,
        UpdatedAt: null,
        DeletedBy: null,
        UpdatedBy: null,
        ExportedAt: null,
        ExportedBy: null,
        ExportFormat: null,
        ExportTarget: null,
        CreatedBy: null,
        ChangedAt: null,
        ChangedBy: null,
        Version: 0
      } as IFieldWorkPlanBook;
    });
  }

  /**
   * Updates an overview item with data from single edit form.
   * @param overviewItem - The overview item to update
   * @param singleEditData - Form data containing updated values
   * @returns Updated overview item with new values, or original item when null
   * @public
   */
  public updateSingleOverviewItem(overviewItem: IFwPlanPlanningWizardOverviewData,
                                  singleEditData: IFwPlanPlanningWizardSingleEditData): IFwPlanPlanningWizardOverviewData {
    if (!overviewItem) {
      return overviewItem;
    }
    const filedGeom = this.fieldStore.getFieldGeomById(overviewItem?.PlanBook?.FieldGeomId);
    const applicationDate = this.dateService.getDateNoon(singleEditData.ApplicationDate);
    const unit = this.unitsStore.Units.find(u => u.Id === singleEditData.Unit);
    const driver = this.driverStore.getDriverById(singleEditData.Driver);
    const machine = this.machineStore.getMachineById(singleEditData.Machine);
    const instrument = this.instrumentStore.getInstrumentById(singleEditData.Instrument);
    const duration = this.timeAreaService.getTotalDurationInMilliseconds(filedGeom?.AreaHa,
      singleEditData.HaPerHour);
    overviewItem.Start = singleEditData.Start;
    overviewItem.HaPerHour = singleEditData.HaPerHour;
    overviewItem.DurationInMilliseconds = duration;
    overviewItem.Unit = this.translationService.translate(unit?.Key);
    overviewItem.Driver = driver?.FirstNameFullName;
    overviewItem.Machine = machine?.NameWithSign;
    overviewItem.Instrument = instrument?.Name;
    overviewItem.PlanBook.Unit = unit;
    overviewItem.PlanBook.ApplicationDate = applicationDate;
    overviewItem.PlanBook.WorkingWidth = instrument?.DefaultWidth ?? 0;
    overviewItem.PlanBook.Note = singleEditData.Notes;
    overviewItem.PlanBook.Value = singleEditData.Value;
    overviewItem.PlanBook.ExportDriver = singleEditData.Driver;
    overviewItem.PlanBook.ExportMachine = singleEditData.Machine;
    overviewItem.PlanBook.ExportInstrument = singleEditData.Instrument;
    overviewItem.PlanBook.Start = ApTimeSpanUtil.getTimeSpanFromDate(singleEditData.Start, true);
    overviewItem.PlanBook.Duration = ApTimeSpanUtil.getTimeSpanFromMilliseconds(duration, true);
    return overviewItem;
  }

  /**
   * Gets single edit data from an overview item for editing in modal dialog
   * @param overviewItem - The overview item containing the plan book and other data
   * @returns Single edit data object with application date, timings, resources, and other fields from overview item
   * @public
   */
  public getSingleEditData(overviewItem: IFwPlanPlanningWizardOverviewData): IFwPlanPlanningWizardSingleEditData {
    const durationInTimeSpan = ApTimeSpanUtil.getTimeSpanFromMilliseconds(overviewItem.DurationInMilliseconds, true);
    return {
      ApplicationDate: overviewItem.PlanBook.ApplicationDate,
      Start: overviewItem.Start,
      Unit: overviewItem.PlanBook.Unit?.Id,
      Value: overviewItem.PlanBook.Value,
      Notes: overviewItem.PlanBook.Note,
      Driver: overviewItem.PlanBook.ExportDriver,
      Machine: overviewItem.PlanBook.ExportMachine,
      Instrument: overviewItem.PlanBook.ExportInstrument,
      DurationInHours: durationInTimeSpan.TotalHours,
      HaPerHour: overviewItem.HaPerHour
    };
  }
}
